import { Organism } from './organism.js';
import { PhoneAbuse } from '../../mobile/modules/faq_phone_abuse.js';
import { ReportAd } from '../../mobile/modules/faq_report_ad.js';
import { PhoneVerification } from '../../mobile/modules/faq_phone_verification.js';

export function initFaqForms($scope) {
	const $abuse = $scope.find('.js-faq_phone_abuse_form');
	const $report = $scope.find('.js-faq_report_ad_form');
	const $verify = $scope.find('.js-faq_phone_verification_form');
	$abuse.each(function() {
		new PhoneAbuse(jQuery(this));
	});
	$report.each(function() {
		new ReportAd(jQuery(this));
	});
	$verify.each(function() {
		new PhoneVerification(jQuery(this));
	});
}

export class OrganismFaq extends Organism {
	init() {
		initFaqForms(this.$root);
	}

	init_forms() {}
}